module.exports = __webpack_public_path__ + "img/tiopan.396e5017.png";